/* eslint-disable */ 

export default {
    state: { 
        profile: {
            editing: false,
            loading: false,
            statusOk: true,
            okMessage: "",
            errMessage: ""
        },
        password: {
            changing: false,
            statusOk: true,
            okMessage: "",
            errMessage: ""
        }
    },
    mutations: {
        'MY_PROFILE_EDIT_LOADING': (state, val) => {
            state.profile.loading = val;
        },
        'MY_PROFILE_EDIT_EDITING': (state, val) => {
            state.profile.editing = val;
        },
        'MY_PROFILE_EDIT_PASSWORD_CHANGING': (state, val) => {
            state.password.changing = val;
        },
        'MY_PROFILE_EDIT_SUCCESS': (state, val) => {
            state.profile.statusOk = true;
            state.profile.okMessage = val
            state.profile.errMessage = "";
        },
        'MY_PROFILE_EDIT_ERROR': (state, val) => {
            state.profile.statusOk = false;
            state.profile.errMessage = val;
            state.profile.okMessage = "";
        },
        'MY_PROFILE_EDIT_PASSWORD_SUCCESS': (state, val) => {
            state.password.statusOk = true;
            state.password.okMessage = val
            state.password.errMessage = "";
        },
        'MY_PROFILE_EDIT_PASSWORD_ERROR': (state, val) => {
            state.password.statusOk = false;
            state.password.okMessage = ""
            state.password.errMessage = val;
        }
    },
    actions: {
        'MY_PROFILE_EDIT_SAVE': ({commit, rootState}, payload) => {
            commit('MY_PROFILE_EDIT_LOADING', true);
            axios.put(`/user/${rootState.authenticatedUserID}`, payload)
                .then(resp => {
                    commit('MY_PROFILE_EDIT_LOADING', false);
                    commit('MY_PROFILE_EDIT_SUCCESS', rootState.locale === "en" ? "Profile successfully updated":"Profiili onnistuneesti päivitetty");
                    commit('MY_PROFILE_EDIT_EDITING', false);
                    commit('AUTH_USER', resp.data.response);
                    console.log(resp);
                })
                .catch(err => {
                    commit('MY_PROFILE_EDIT_LOADING', false);
                    commit('MY_PROFILE_EDIT_ERROR', rootState.locale === "en" ? "Profile failed to update":"Profiilia ei voitu päivittää");
                    console.log(err.response);
                });
        },
        'MY_PROFILE_EDIT_CHANGE_PASSWORD': ({commit, rootState}, payload) => {
            commit('MY_PROFILE_EDIT_PASSWORD_CHANGING', true);
            axios.put(`/user/${rootState.authenticatedUserID}/password`, payload)
                .then(resp => {
                    commit('MY_PROFILE_EDIT_PASSWORD_CHANGING', false);
                    commit('MY_PROFILE_EDIT_PASSWORD_SUCCESS', rootState.locale === "en" ? "Password successfully changed":"Salasana onnistuneesti vaihdettu");
                    console.log(resp);
                })
                .catch(err => {
                    commit('MY_PROFILE_EDIT_PASSWORD_CHANGING', false);
                    commit('MY_PROFILE_EDIT_PASSWORD_ERROR', rootState.locale === "en" ? "Password failed to change":"Salasanaa ei voitu vaihtaa");
                    console.log(err.response);
                });
        }
    }
}